module.exports = __webpack_public_path__ + "fonts/dm-sans-v6-latin-700.082b291.woff";